import {
  List,
  Datagrid,
  ChipField,
  TextField,
  RichTextField,
  DeleteWithConfirmButton,
  Edit,
  SimpleForm,
  SelectInput,
  TextInput,
  Create,
  Show,
  SimpleShowLayout,
  BooleanInput,
  ReferenceField,
  BooleanField,
  DateField,
  required,
} from 'react-admin'

// import { RichTextInput} from 'ra-input-rich-text'

import { USER_TYPE_OPTIONS, PHASE_TYPE_OPTIONS } from '../config/constants'

// <List filters={postFilters}>
// const postFilters = [
//     <TextInput source='q' label='Search' alwaysOn />,
//     <ReferenceInput source='userId' label='User' reference='users' />,
// ]

// <Edit title={<PostTitle />}>
// const PostTitle = () => {
//   const record = useRecordContext()
//   return <span>Post {record ? `'${record.title}'` : ''}</span>
// }

export const PhaseList = ({ isEdit, isDelete }) => (
  <List>
    <Datagrid bulkActionButtons={false} rowClick={isEdit ? "edit" : "show"}>
      <ChipField source="userType" />
      <BooleanField source="isOverweight" />
      <ChipField source="type" />
      <TextField source="title" />
      <TextField source="shortDescription" />
      <DateField source="updatedAt" label="Updated At" showTime />
      <ReferenceField source="updatedBy" reference="users" />
      {isDelete && <DeleteWithConfirmButton confirmContent="This action could not be reverted. Are you sure?" />}
    </Datagrid>
  </List>
)

export const PhaseEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="title" />
      <TextInput source="shortDescription" fullWidth multiline />
      <TextInput source="detailedDescription" fullWidth multiline />
    </SimpleForm>
  </Edit>
)

export const PhaseCreate = () => (
  <Create>
    <SimpleForm>
      <SelectInput source="userType"choices={USER_TYPE_OPTIONS} validate={required()} />
      <BooleanInput source="isOverweight" label="Is Overweight" validate={required()} />
      <SelectInput source="type" choices={PHASE_TYPE_OPTIONS} validate={required()} />
      <TextInput source="title" validate={required()} />
      <TextInput source="shortDescription" fullWidth multiline validate={required()} />
      <TextInput source="detailedDescription" fullWidth multiline validate={required()} />
    </SimpleForm>
  </Create>
)

export const PhaseShow = () => (
  <Show>
    <SimpleShowLayout>
      <ChipField source="userType" />
      <BooleanField source="isOverweight" />
      <ChipField source="type" />
      <TextField source="title" />
      <RichTextField source="shortDescription" />
      <RichTextField source="detailedDescription" />
      <DateField source="updatedAt" label="Updated At" showTime />
      <ReferenceField source="updatedBy" reference="users" />
    </SimpleShowLayout>
  </Show>
)
